module.exports = __webpack_public_path__ + "img/generate_RN.9ba61453.svg";